


































































import { Component, Vue, Watch } from 'vue-property-decorator';

/**
 * API
 */
import transactionsAPI from "@/api/transactions";

/**
 * Helpers
 */
import { sortByAsc, sortByDesc } from "@/utils/sort-helpers";

/**
 * Mixins
 */
import mixinsDate from "@/mixins/date-mixins";

/**
 * Types
 */
import { FilterModel } from "@/components/_global/FilterControl.vue";

/**
 * Page de liste des transactions (historique des mouvements).
 */
@Component({ mixins: [mixinsDate] })
export default class TransactionsListPage extends Vue {
    /** Attributs */
    isLoading = false;
    transactions: any[] = [];
    pagination = {
        sortBy: 'creationDate',
        descending: true,
    };
    headers = [
        {
            text: '',
            value: null,
            align: 'left'
        },
        {
            text: 'transaction.creation_date',
            value: 'creationDate',
            align: 'left'
        },
        {
            text: 'transaction.account',
            value: 'account.label',
            align: 'left'
        },
        {
            text: 'transaction.label',
            value: 'label',
            align: 'left'
        },
        {
            text: 'transaction.paymentMean',
            value: 'paymentMean',
            align: 'left'
        },
        {
            text: 'transaction.amount',
            value: 'amount',
            align: 'right'
        },
        {
            text: '',
            value: null,
            align: 'right'
        },
    ];

    filterModel: FilterModel | null = null;

    get filtersDefinitions() {
        return {
            0: {
                label: this.$t('transaction.account'),
                value: (x: any) => x.label,
                key: 'id',
                items: this.transactions.reduce((acc, curr) => [...acc, curr.account], []).sort(sortByAsc((x) => x.label)),
                f: (keySelected: number) => (x: any) => x.account.id === keySelected
            },
            1: {
                label: this.$t('transaction.state'),
                value: 'value',
                key: 'key',
                items: this.transactions.reduce((acc, curr) => [
                    ...acc,
                    {
                        key: curr.isSynchronized,
                        value: curr.isSynchronized ? this.$t(`transaction.validated`) : this.$t(`transaction.pending`)
                    }
                ], []),
                f: (keySelected: number) => (x: any) => x.isSynchronized === keySelected
            },
        };
    }

    get displayedTransactions() {
        return this.filterModel ? this.transactions.filter(this.filterModel.predicate) : this.transactions;
    }

    /** Méthodes */
    async created() {
        this.isLoading = true;
        this.transactions = await transactionsAPI.getAll();
        this.isLoading = false;
    }
    showMenu: any = {};
    async handleMoreClick(id: number) {
        this.showMenu = {};
        this.showMenu[id] = true;
    }



}
